import {
  hasCookieScriptConsent,
  subscribeToCookieScriptConsentChanges
} from "./cookie_script_consent";

const YOUTUBE_CONSENT_CATEGORY = "functionality";
const YOUTUBE_MODAL_ID = "youtube-modal";

document.addEventListener("turbo:load", () => {
  const youtubeLinks = document.querySelectorAll(
    'a[data-youtube-modal-link="true"][href*="//www.youtube.com/watch"], a[data-youtube-modal-link="true"][href*="//www.youtube-nocookie.com/watch"]'
  );

  for (const link of youtubeLinks) {
    if (link.dataset.youtubeModalBound === "true") {
      continue;
    }

    link.addEventListener('click', openYoutubeModal);
    link.dataset.youtubeModalBound = "true";
  }
});

function openYoutubeModal(event) {
  event.preventDefault();

  const embedURL = convertToEmbedURL(this.href);
  const modalContent = youtubeModalContent(embedURL);
  const existingModal = document.getElementById(YOUTUBE_MODAL_ID);
  if (existingModal?.closeYoutubeModal) {
    existingModal.closeYoutubeModal();
  } else {
    existingModal?.remove();
  }

  const modalDialog = document.createElement("div");
  modalDialog.id = YOUTUBE_MODAL_ID;
  modalDialog.setAttribute("class", "tw:relative tw:z-10");
  modalDialog.setAttribute("aria-labelledby", "Youtube modal");
  modalDialog.setAttribute("role", "dialog");
  modalDialog.setAttribute("aria-modal", "true");
  modalDialog.innerHTML = `
    <div class="tw:fixed tw:inset-0 tw:bg-black tw:transition-opacity"></div>
    <div class="tw:fixed tw:z-10 tw:inset-0 tw:overflow-y-auto">
      <div class="tw:flex tw:items-center tw:items-center tw:justify-center tw:min-h-full tw:p-4 tw:text-center tw:sm:p-0">
        <div class="tw:sm:block tw:absolute tw:top-6 tw:right-6">
          <button type="button" class="tw:bg-black tw:border-0 tw:text-white tw:hover:text-gray-500 tw:outline-hidden">
            <!-- Heroicon name: outline/x -->
            <svg class="tw:h-10 tw:w-10" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12"/>
            </svg>
          </button>
        </div>
        <div class="tw:relative tw:aspect-video tw:w-full tw:sm:w-8/12" data-youtube-modal-content>
          ${modalContent}
        </div>
      </div>
    </div>
      `
  const contentContainer = modalDialog.querySelector("[data-youtube-modal-content]");

  const renderModalContent = () => {
    contentContainer.innerHTML = youtubeModalContent(embedURL);
  };

  const unsubscribeFromConsentChanges = subscribeToCookieScriptConsentChanges(
    YOUTUBE_CONSENT_CATEGORY,
    renderModalContent
  );

  const closeModal = () => {
    unsubscribeFromConsentChanges();
    document.removeEventListener("keydown", handleKeydown);
    modalDialog.remove();
  };

  const handleKeydown = (event) => {
    if (event.key === "Escape") {
      closeModal();
    }
  };

  modalDialog.closeYoutubeModal = closeModal;

  contentContainer.addEventListener("click", function (event) {
    event.stopPropagation();
  });

  modalDialog.addEventListener('click', function (event) {
    closeModal();
  });

  // close modalDialog on escape key
  // does not work, when the use interact with the youtube iframe
  document.addEventListener("keydown", handleKeydown);

  document.body.append(modalDialog);
}

function youtubeModalContent(embedURL) {
  if (hasCookieScriptConsent(YOUTUBE_CONSENT_CATEGORY)) {
    return `
      <iframe class="tw:absolute tw:inset-0 tw:h-full tw:w-full"
              id="youtubeIframe"
              src="${embedURL}"
              frameborder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen></iframe>
    `;
  }

  return `
    <div class="tw:absolute tw:inset-0 tw:flex tw:items-center tw:justify-center tw:bg-black tw:p-6 tw:text-center tw:text-white">
      <div class="tw:relative tw:z-10 tw:flex tw:max-w-md tw:flex-col tw:items-center tw:gap-3">
        <p class="tw:m-0 tw:text-base tw:text-center tw:font-semibold tw:leading-6">
          YouTube video blocked
        </p>

        <p class="tw:m-0 tw:text-center tw:text-sm tw:leading-5 tw:text-white/80">
          Allow YouTube under the Functionality cookie category to load this video.
        </p>

        <a href="#"
           role="button"
           class="cookie-script-settings-button tw:mt-1 tw:rounded-md tw:border tw:border-white/40 tw:bg-white tw:px-4 tw:py-2 tw:text-sm tw:font-semibold tw:text-black tw:no-underline tw:transition-colors tw:hover:bg-zinc-200">
          Privacy Settings
        </a>
      </div>
    </div>
  `;
}

function convertToEmbedURL(url) {
  const watchURL = new URL(url, window.location.href);
  const videoID = watchURL.searchParams.get("v");

  if (!videoID) {
    return url;
  }

  const embedURL = new URL(`https://www.youtube-nocookie.com/embed/${videoID}`);
  embedURL.searchParams.set("rel", "0");
  embedURL.searchParams.set("iv_load_policy", "3");
  embedURL.searchParams.set("showinfo", "0");
  embedURL.searchParams.set("modestbranding", "1");
  embedURL.searchParams.set("autoplay", "1");

  const startTime = watchURL.searchParams.get("t") || watchURL.searchParams.get("start");
  if (startTime) {
    embedURL.searchParams.set("start", startTime.replace(/s$/, ""));
  }

  return embedURL.toString();
}
